"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _ErrorPage = _interopRequireDefault(require("../components/pages/ErrorPage"));

var _HomePage = _interopRequireDefault(require("../components/pages/HomePage"));

var _ResultsPage = _interopRequireDefault(require("../components/pages/ResultsPage"));

var _InputUtil = _interopRequireDefault(require("../util/InputUtil"));

var _Paths = require("../constants/Paths");

var getSanitizedHostname = function getSanitizedHostname(websiteUrl) {
  return _InputUtil.default.parseWebsiteUrl(decodeURIComponent(websiteUrl));
};

var ProtectedResultsPage = function ProtectedResultsPage() {
  var _useParams = (0, _reactRouterDom.useParams)(),
      websiteUrl = _useParams.websiteUrl;

  var hostname = getSanitizedHostname(websiteUrl);
  return hostname === websiteUrl ? _react.default.createElement(_ResultsPage.default, null) : _react.default.createElement(_reactRouterDom.Redirect, {
    to: _Paths.TESTS + "/" + hostname
  });
};

var _default = function _default() {
  return _react.default.createElement(_reactRouterDom.Switch, null, _react.default.createElement(_reactRouterDom.Route, {
    path: _Paths.TESTS + "/:websiteUrl",
    component: ProtectedResultsPage
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: _Paths.ERROR + "/:errorType?",
    component: _ErrorPage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: _Paths.ROOT,
    exact: true,
    component: _HomePage.default
  }), _react.default.createElement(_reactRouterDom.Redirect, {
    to: _Paths.ROOT
  }));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/lib/routes.js
// module id = 166
// module chunks = 0